var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 5,
    fill: "#FFCC00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.252 11.4775V30H12.5957V15.6924L8.20312 17.0889V14.207L15.8584 11.4775H16.252ZM34.9141 27.1436V30H22.2695V27.5625L28.249 21.1514C28.8499 20.4827 29.3239 19.8945 29.6709 19.3867C30.0179 18.8704 30.2676 18.4092 30.4199 18.0029C30.5807 17.5882 30.6611 17.1947 30.6611 16.8223C30.6611 16.2637 30.568 15.7855 30.3818 15.3877C30.1956 14.9814 29.9206 14.6683 29.5566 14.4482C29.2012 14.2282 28.7611 14.1182 28.2363 14.1182C27.6777 14.1182 27.1953 14.2536 26.7891 14.5244C26.3913 14.7952 26.0866 15.1719 25.875 15.6543C25.6719 16.1367 25.5703 16.6826 25.5703 17.292H21.9014C21.9014 16.1917 22.1637 15.1846 22.6885 14.2705C23.2132 13.348 23.9538 12.6159 24.9102 12.0742C25.8665 11.5241 27.0007 11.249 28.3125 11.249C29.6074 11.249 30.6992 11.4606 31.5879 11.8838C32.485 12.2985 33.1621 12.8994 33.6191 13.6865C34.0846 14.4652 34.3174 15.3962 34.3174 16.4795C34.3174 17.0889 34.2201 17.6855 34.0254 18.2695C33.8307 18.8451 33.5514 19.4206 33.1875 19.9961C32.832 20.5632 32.4004 21.1387 31.8926 21.7227C31.3848 22.3066 30.8219 22.9118 30.2041 23.5381L26.9922 27.1436H34.9141Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR12);
export default __webpack_public_path__ + "static/media/R12.9868d852fb3640c089a5cb82fb469d93.svg";
export { ForwardRef as ReactComponent };